import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import {put, takeEvery, all, fork, takeLatest} from "redux-saga/effects";
import BranchService from '../../services/branch.service'
import { act } from "react-dom/test-utils";
import { Restaurant } from "@material-ui/icons";


function* getBranchDropdownList(action) {
  try {
    if (action.payload) {
      const response = yield BranchService.list(action.payload);//params
      if (response?.data.statusCode === 200) {
        yield put(actions.getBranchDropdownListSuccess(response.data));
      } else {
        yield put(actions.getBranchDropdownListFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.getBranchDropdownListFailure(error));
  }
}

function* getBranchDropdownListSaga() {
  yield takeEvery(actionsTypes.GET_BRANCH_DROPDOWN_LIST_START, getBranchDropdownList);
}

function* getBranchList(action) {
  try {
    if (action.payload) {
      const response = yield BranchService.list(action.payload);//params
      if (response?.data.statusCode === 200) {
        yield put(actions.getBranchListSuccess(response.data));
      } else {
        yield put(actions.getBranchListFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.getBranchListFailure(error));
  }
}

function* getBranchListSaga() {
  yield takeEvery(actionsTypes.GET_BRANCH_LIST_START, getBranchList);
}

function* addBranch(action) {
  try {
    if (action.payload) {
      const payload = action.payload;
      const data = new FormData();
      const coordinates = payload.coordinates;
      const timing = payload.timing;
      const payment_gateway_ids = payload.payment_gateway_ids;
      data.append('address',payload.address);
      data.append('country',payload.country);
      data.append('city',payload.city);
      data.append('state',payload.state);
      data.append('mobile_no',payload.mobile_no);
      data.append('status',payload.status);
      data.append('file',payload.file);
      payment_gateway_ids.map((payment_gateway) => {
        data.append('payment_gateway_ids',payment_gateway.value);
      });
      // data.append('coordinates',payload.coordinates);
      coordinates.map( coordinate=> {
        data.append('coordinates',coordinate);
      });

      // data.append('timing',payload.timing);
      timing.map(time =>{data.append('timing',time)});
      data.append('currency',payload.currency);
      data.append('service_fee',payload.service_fee);
      // data.append('timing',payload.timing);

      data.append('restaurant_id',payload.restaurant_id);

      // data.appebd('domain',payload.donain)
      data.append('pay_now',payload.pay_now);
      const response = yield BranchService.add(data);
      // const response = yield BranchService.add(action.payload);//params
      if (response?.data.statusCode === 201) {
        yield put(actions.addBranchSuccess(response.data));
      } else {
        yield put(actions.addBranchFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.addBranchFailure(error));
  }
}

function* addBranchSaga() {
  yield takeEvery(actionsTypes.ADD_BRANCH_START, addBranch);
}

function* updateBranch(action) {
  try {
    if (action.payload) {
      const branchId = action.payload?._id;
      const payload = action.payload;
      const data = new FormData();
      const coordinates = payload.coordinates;
      const timing = payload.timing;
      const payment_gateway_ids = payload.payment_gateway_ids;
      data.append('address',payload.address);
      data.append('country',payload.country);
      data.append('city',payload.city);
      data.append('state',payload.state);
      data.append('mobile_no',payload.mobile_no);
      data.append('status',payload.status);
      data.append('file',payload.file);
      payment_gateway_ids?.map((payment_gateway) => {
        data.append('payment_gateway_ids',payment_gateway.value);
      });
      // data.append('coordinates',payload.coordinates);
      coordinates?.map( coordinate=> {
        data.append('coordinates',coordinate);
      });

      // data.append('timing',payload.timing);
      timing.map(time =>{data.append('timing',time)});
      data.append('currency',payload.currency);
      if(payload.service_fee)
        data.append('service_fee',payload.service_fee);
      // data.append('timing',payload.timing);
      data.append('vat',payload.vat);
      data.append('restaurant_id',payload.restaurant_id);

      // data.appebd('domain',payload.donain)
      data.append('pay_now',payload.pay_now);
      const response = yield BranchService.update(data,branchId);//params ,action.payload
      if (response?.data.statusCode === 200) {
        yield put(actions.updateBranchSuccess(response.data));
      } else {
        yield put(actions.updateBranchFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.updateBranchFailure(error));
  }
}

function* updateBranchSaga() {
  yield takeEvery(actionsTypes.UPDATE_BRANCH_START, updateBranch);
}

export function* branchSaga() {
  yield all([fork(getBranchDropdownListSaga), fork(getBranchListSaga), fork(addBranchSaga), fork(updateBranchSaga)]);
}
